module.exports = __webpack_public_path__ + "static/media/caddie.2ded7191.svg";